"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchaseCommand = void 0;
class PurchaseCommand {
    constructor(input) {
        this.input = input;
    }
    execute(config) {
        const { value, currency, contents, content_type } = this.input;
        const { fbq: facebookQueue } = config;
        const object = {
            value: value,
            currency: currency,
            contents: contents?.map((content) => ({
                id: `${content.id}`,
                quantity: +content.quantity,
            })) ?? [],
            content_ids: contents?.map((content) => `${content.id}`) ?? [],
            content_type: content_type ?? 'product',
        };
        facebookQueue('track', 'Purchase', object);
        facebookQueue('trackCustom', 'PurchaseWeb', object);
        return Promise.resolve();
    }
}
exports.PurchaseCommand = PurchaseCommand;
